import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

import indexRouter from '@/router/modules/index'
import demoRouter from '@/router/modules/demo'
import doPayRouter from '@/router/modules/dopay'
import infoRouter from '@/router/modules/info'
import tradeRouter from '@/router/modules/trade'
import bankCardRouter from '@/router/modules/bank-card'
import securityRouter from '@/router/modules/security'
import registerRouter from '@/router/modules/register'
import forceTelRouter from '@/router/modules/forceTel'
import findLoginPwdRouter from '@/router/modules/findLoginPwd'

export const routes = [
  {
    path: '/',
    component: Layout,
    redirect: 'login',
    hidden: true
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/login/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/tempindex'),
    hidden: true
  },
  {
    path: '/cusList',
    component: () => import('@/views/cusList/index'),
    name: 'cusList',
    hidden: true
  },
  {
    path: '/auth',
    name: 'auth',
    meta: {
      title: '实名认证'
    },
    component: () => import('@/views/auth/auth')
  },
  indexRouter,
  demoRouter,
  doPayRouter,
  infoRouter,
  tradeRouter,
  bankCardRouter,
  securityRouter,
  registerRouter,
  forceTelRouter,
  findLoginPwdRouter
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
export default router
